import { onError } from "@apollo/client/link/error";
import { handleLogoutWithoutHook } from "Entity/LogoutHandler";
import {
    isAuthRelatedGraphqlError,
    isAuthRelatedNetworkError,
    setAuthLogoutFlash,
} from "Utils/graphqlAuthErrors";

/**
 * ErrorLink observes and handles errors from GraphQL operations.
 *
 * Link chain (request):  RetryLink → ErrorLink → HttpLink → Server
 * Link chain (response): RetryLink ← ErrorLink ← HttpLink ← Server
 *
 * How it works:
 * 1. Requests flow forward through the chain
 * 2. Responses/errors flow backward through the chain
 * 3. onError is only called when there's an error
 * 4. RetryLink (before this) decides whether to retry based on retryIf logic
 * 5. This link observes errors and handles special cases (like auth failures)
 */
export const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (networkError) {
        if (isAuthRelatedNetworkError(networkError)) {
            console.error(
                "ErrorLink: Authentication network error - logging out user",
            );
            setAuthLogoutFlash();
            handleLogoutWithoutHook();
            return;
        }

        if (networkError.message?.includes("Failed to fetch")) {
            console.error(
                "ErrorLink: Network fetch failed:",
                networkError.message,
            );
            return;
        }
    }

    if (graphQLErrors) {
        for (const err of graphQLErrors) {
            if (isAuthRelatedGraphqlError(err)) {
                console.error(
                    "ErrorLink: Authentication error in GraphQL response - logging out user",
                );
                setAuthLogoutFlash();
                handleLogoutWithoutHook();
                return;
            }
        }
    }
});
